import { Component, ComponentType, JSX } from 'react';
import { Authentication } from '../components/Authentication';

export interface IAuthenticatedProps {
    server?: string;
}

export const requireAuth = <TOriginalProps,>(MyComponent: ComponentType<TOriginalProps>) => {
    return class Authenticated extends Component<TOriginalProps & IAuthenticatedProps> {
        public render(): JSX.Element {
            return <Authentication render={this.renderHoc} />;
        }

        private readonly renderHoc = () => {
            return <MyComponent {...this.props} />;
        };
    };
};
